import * as analytics from './selectors.analytics';
import * as bars from './selectors.bars';
import * as base from './selectors.base';
import * as gallery from './selectors.gallery';
import * as parameters from './selectors.parameters';
import { raw } from './selectors.raw';
import * as realtime from './selectors.realtime';
import * as single from './selectors.single';
import * as tables from './selectors.tables';

export const selectors = {
  raw,
  analytics,
  bars,
  base,
  single,
  parameters,
  realtime,
  tables,
  gallery,
};
